import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import deTranslations from "../../translations/de.json";
import enTranslations from "../../translations/en.json";

export const resources = {
  de: {
    translation: deTranslations,
  },
  en: {
    translation: enTranslations,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "de",
  fallbackLng: "de",
  supportedLngs: Object.keys(resources),
  interpolation: {
    escapeValue: false,
  },
});
